import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { TextField } from "@material-ui/core";

const ConfirmDelete = ({
	open = false,
	handleClose,
	handleConfirm,
	title = "",
	description = "",
}) => {
	const [value, setValue] = useState("");

	useEffect(() => {
		setValue("");
	}, [value]);

	return (
		<Dialog
			open={open}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description">
			<DialogTitle id="alert-dialog-title">{title}</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					{description}
				</DialogContentText>
				<DialogContentText>
					Для підтвердження введіть <strong>ВИДАЛИТИ</strong>:
				</DialogContentText>
				<TextField
					fullWidth
					autoFocus
					margin="dense"
					id="name"
					value={value}
					variant="standard"
					onInput={(e) => setValue(e.target.value)}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} color="primary">
					Скасувати
				</Button>
				<Button
					disabled={value !== "ВИДАЛИТИ"}
					onClick={handleConfirm}
					color="secondary"
					autoFocus>
					Підтвердити
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmDelete;
